import { useEffect, useLayoutEffect, useState } from 'react';
import {
    DELIVERED_SERVICES_SEARCH_MODEL,
    MODEL_CONTEXT_DELIVERED_SERVICES,
    TABS_DELIVERED_SERVICES
} from '../Model/Model';
import HandleChange from '../../../../Helpers/HandleChange';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { permissionObj } from '../../../../Helpers/permission';
import { useDeliveredServicesContextProvider } from './DeliveredServicesContextProvider';
import { useLocation } from 'react-router-dom';
import {TABLES} from "../../../../Apis/Tables";
import {MODELS} from "../../../../Apis/Models";
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const DeliveredServicesMainApp = () => {
    const { t } = useTranslation();
    const [steps, setSteps] = useState([]);
    const location = useLocation();
    let { state } = location;
    const currentTab = state?.currentTab;
    const [activeStep, setActiveStep] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [isOnline, setIsOnline] = useState(false);
    const [modified, setModified] = useState(false);
    const [item, setItem] = useState(null);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [search, setSearch] = useState('');
    const [moduleId, setModuleId] = useState(null);
    const [option, setOption] = useState(null);
    const [bodyForExport, setBodyForExport] = useState(null);
    const { paramsContext, setParamsContext } = useDeliveredServicesContextProvider();
    const [emptyFields, setEmptyFields] = useState(false);

    /**
     * Initializes context parameters if they are not already defined.
     * This ensures default values are set when the component mounts.
     */
    useLayoutEffect(() => {
        if (!paramsContext) {
            setParamsContext({ ...MODEL_CONTEXT_DELIVERED_SERVICES });
        }
    }, []);

    /**
     * Builds the step configuration dynamically based on permissions.
     * Only tabs with valid permissions (or DEV mode enabled) are included.
     * Also determines the first accessible tab as the default active tab.
     */
    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            {
                tab: TABS_DELIVERED_SERVICES.SERVICES.TRANS,
                perm: [permissionObj?.WEB_FOODIE_KITCHEN_ACCESS_READ],
                index: TABS_DELIVERED_SERVICES.SERVICES.INDEX,
            },
            {
                tab: TABS_DELIVERED_SERVICES.HISTORY.TRANS,
                perm: [permissionObj?.WEB_FOODIE_KITCHEN_ACCESS_HISTORY_READ],
                index: TABS_DELIVERED_SERVICES.HISTORY.INDEX,
            },
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some((p) => permission?.includes(p));
            if (hasPermission) {
                acc.push({ label: t(tab), index });
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        if (activeStep === null && activeTab !== null && !paramsContext?.tabIndex && !currentTab) {
            handleStepChange(activeTab);
        }
    }, [t, permission]);

    /**
     * Syncs active tab from context if it exists.
     * Ensures tab state persistence when navigating back.
     */
    useEffect(() => {
        if (paramsContext?.tabIndex) {
            handleStepChange(paramsContext?.tabIndex);
        }
    }, []);

    /**
     * Syncs active tab from navigation state when location changes.
     */
    useLayoutEffect(() => {
        if (currentTab) handleStepChange(currentTab);
    }, [location]);

    /**
     * Handles step (tab) change.
     * - Resets search input.
     * - Updates active step.
     * - Stores selected tab index in context.
     */
    const handleStepChange = (step) => {
        setItem(DELIVERED_SERVICES_SEARCH_MODEL.clear());
        setEmptyFields(false);
        setBodyForExport(null);

        if(step === TABS_DELIVERED_SERVICES.SERVICES.INDEX){
            setOption(TABLES.KITCHEN_ACCESS);
            setModuleId(MODELS.KITCHEN_ACCESS);
        }else{
            setIsOnline(false);
            setOption(TABLES.KITCHEN_ACCESS_HISTORY);
            setModuleId(MODELS.KITCHEN_ACCESS_HISTORY);
        }

        setActiveStep(step);
        if (setParamsContext) {
            setParamsContext((prev) => ({
                ...prev,
                tabIndex: step,
            }));
        }
    };

    /**
     * Function to validate permissions for the create and delete buttons. It can also be applied to import, export, and search buttons.
     * If no permission is assigned or the tabIndex variable from the Context is null, the button is not displayed.
     * @param array list: List of permissions based on the active tab.
     * @returns {boolean}
     */
    const permissionButtons = (list) => {
        if (paramsContext?.tabIndex == null) {
            return false;
        }
        const permissionRequired = list[paramsContext?.tabIndex];

        if (!permissionRequired) {
            return false;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    return {
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        isOnline,
        item,
        setItem,
        handleChange,
        search,
        setIsOnline,
        modified,
        setModified,
        moduleId,
        bodyForExport,
        setBodyForExport,
        option,
        permissionButtons,
        emptyFields,
        setEmptyFields
    };
};

export default DeliveredServicesMainApp;
